<script>
    import axios from 'axios'
    import moment from 'moment'

    export let data = null

    let datestring = '',
        timestring = ''


    const evaluateCronstring = (string) => {
        axios.request ({
            method: 'get',
            url: '/api/alerts/evaluate/?cron=' + string
        }).then (results => {
            let mmnt = moment (results.data.date);
            datestring = mmnt.format ('dddd, DD MMMM YYYY')
            timestring = mmnt.format ('HH:mm')
        })
    }

    $: {
        evaluateCronstring (data)
    }
</script>

<style>
    .CronEvaluator {
        padding: 20px;
    }
    .CronEvaluator .lbl {
        font-weight: 600;
    }
    .CronEvaluator .icon {
        font-size: 50px;
    }
</style>

<div class="CronEvaluator">
    {#if data}
        <div class="icon">
            <i class="fad fa-calendar-exclamation"></i>
        </div>
        <div class="HumanReadable">
            
        </div>
        <div class="NextDue">
            <div class="lbl">Prossima scadenza</div>
            <div>{datestring}</div>
            <div>Ore: {timestring}</div>
        </div>
    {/if}
</div>